import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { Link } from 'gatsby-theme-material-ui';
import styles from './styles';
import { StaticImage } from 'gatsby-plugin-image';

const descriptionFont = (variant) =>
  ({ desktopH1: 'desktopP2', desktopH0: 'desktopP1' })[variant];

function StatisticItem({
  value,
  description,
  link,
  variant = 'desktopH1',
  noWrapLink = false,
  image,
}) {
  return (
    <Box sx={styles.itemContainer}>
      <Box
        sx={{ width: { xs: 32, lg: 50 }, height: { xs: 32, lg: 50 }, mb: 2 }}
      >
        {image}
      </Box>
      {value ? (
        <Typography sx={styles.value} component="p" variant={variant}>
          {value}
        </Typography>
      ) : (
        <Skeleton width={'100%'} height={72} />
      )}

      {!description && !link && <Skeleton width={200} height={45} />}

      {description && (
        <Typography
          color="kit.text.main"
          variant={descriptionFont(variant)}
          sx={styles.description}
        >
          {description}
        </Typography>
      )}

      {link && (
        <Link
          target="_blank"
          to={link.url}
          variant="kitPrimary"
          typography="desktopP2"
          sx={{
            ...(noWrapLink ? { textWrap: 'nowrap' } : {}),
            fontSize: {
              xs: 14,
              md: 16,
            },
          }}
        >
          {link.title}
        </Link>
      )}
    </Box>
  );
}

export default StatisticItem;
